import { useTranslation } from 'react-i18next';
import { Callout } from '@/components/common';
import { useCurrentUser } from '@/contexts';
import { useViewerLocation } from '@/hooks';
import { formatLocationOverride } from '@/utils/geo';

/**
 * Reminder shown while an admin location override is active: the viewer is
 * browsing near a place that isn't where their profile appears to others.
 * Renders nothing for regular users or when no override is set.
 */
export function LocationOverrideBanner() {
  const { t } = useTranslation('discover');
  const { settings } = useCurrentUser();
  const { isOverride } = useViewerLocation();

  if (!isOverride) return null;

  return (
    <Callout variant="soft" size="1" highContrast>
      {t('locationOverride.banner', {
        place: formatLocationOverride(settings?.locationOverride),
      })}
    </Callout>
  );
}
